import React, {useState, useEffect, Fragment} from "react";
import styled from "styled-components";
import PullToRefresh from "react-simple-pull-to-refresh";
import {useLocation, useNavigate, useParams} from "react-router";
import {useSelector} from "react-redux";

import {api} from "utils";
import {getCommaNumber} from "utils/format";

import MainLayout from "layouts/MainLayout";
import Button from "components/ui/Button";
import Badge from "components/ui/Badge";
import PassInfo from "./PassInfo";
import PaymentForm from "./PaymentForm";
import PullToRefreshing from "components/common/PullToRefreshing";
import {getServiceTypeColor, getServiceTypeName} from "../../../utils/define";



/**
 * [주문 결제 상세]
 */

export const PaymentInfo = (props) => {
	const navigate = useNavigate();
	const location = useLocation()
	const {seqOrderPayment} = useParams();
	const {serviceType} = location.state || {};

	const [data, setData] = useState({});
	const [isLoading, setLoading] = useState(true);
	const [isError, setError] = useState(false);

	useEffect(() => {
		eventHandler.update();
	}, [seqOrderPayment]);

	const eventHandler = {
		update : () => {
			api.get("/sales/order/details/" + seqOrderPayment).then(({data}) => {
				setData(data || {});
			}).catch(error => {
				setError(true);
			}).finally(() => {
				setLoading(false);
			});
		},
		pullToRefresh: () => {
			return new Promise((resolve) => {
				setTimeout(() => {
					eventHandler.update();
					resolve();
				}, 700);
			});
		}
	};

	const render = () => {
		const isCancel = (data.orderState == "CANCELLED");
		const isRefund = (data.orderType == "TRANSFER");

		const getTitle = () => {
			const orderPayType = (data.webAppDiv == "A") ? "b.pay" : "현장판매";
			const orderName = (data.orderName || "(이름없음)").recoverTag();
			const serviceTypeName = getServiceTypeName(serviceType);
			const serviceTypeColor = getServiceTypeColor(serviceType);
			return (isRefund) ? (
				<div className="title">
					<h5 className="gray">{orderName}</h5>
					<h2>양도 수수료</h2>
				</div>
			) : (
				<div className="title">
					{
						(serviceType) ?
							<h5 className={serviceTypeColor}>{serviceTypeName}</h5> :
							<h5 className="blue">{orderPayType}</h5>
					}
					<h2>{orderName}</h2>
				</div>
			);
		};

		const getPaymentInfo = () => {
			const paymentColor = (isCancel) ? "" : "blue";
			const paymentAmount = getCommaNumber(data.paymentAmount * ((isCancel) ? -1 : 1)) + "원";

			const getPaymentDateTime = () => {
				const dateFormat = "yyyy. sm. sd. sw · hh:MM:ss";
				const date = (isCancel) ? data.orderCancelledDatetime :
					data.paymentDatetime || data.paymentCompletedDatetime;
				return new Date(date).format(dateFormat);
			};
			const getPaymentDateLabel = () => {
				return (isCancel) ? "취소일시" : "결제일시";
			};
			const getPaymentKind = () => {
				switch(data.paymentClassification) {
					case "ORDER" : return <Badge color="green">판매 결제</Badge>;
					case "RECEIVABLES" : return <Badge color="red">미수금 결제</Badge>;
					case "REPAYMENT" : return <Badge color="yellow">환불 시 재결제</Badge>;
					case "TRANSFER" : return <Badge color="purple">양도 수수료</Badge>;
					case "CANCELLED" : return <Badge color="red">판매 취소</Badge>;
				}
				return "-";
			};
			const getPaymentType = () => {
				switch(data.paymentType) {
					case "CARD" : return `카드 ${data.installmentPeriod || 0}개월`;
					case "TRANSFER" : return "이체";
					case "CASH" : return "현금";
				}
			};

			return (
				<div className="paymentInfo">
					<h4>결제 정보</h4>
					<ul>
						<li><div>{getPaymentDateLabel()}</div><div>{getPaymentDateTime()}</div></li>
						<li><div>결제분류</div><div>{getPaymentKind()}</div></li>
						<li><div>결제금액</div><div className={paymentColor}><b>{paymentAmount}</b></div></li>
						<li><div>결제정보</div><div>{getPaymentType()}</div></li>
						<li><div>회원명</div><div>{data.name}</div></li>
						<li><div>결제 담당자</div><div>{data.coachName}</div></li>
					</ul>
				</div>
			);
		};

		return (
			<PullToRefresh
				onRefresh={eventHandler.pullToRefresh}
				resistance={2}
				pullingContent={<></>}
				refreshingContent={<PullToRefreshing />}
			>
				<MainLayout
					withHeader={true}
					headerProps={{
						withBackButton : true,
						centerTitle : "상세 내역"
					}}
					backgroundColor="white"
					withBottomTab={false}
					isLoading={isLoading}
					isError={isError}
				>
					<PaymentForm>
						<div className="color">
							{getTitle()}
							{getPaymentInfo()}
							<PassInfo data={data} />
						</div>
						<Button color="blue" onClick={() => {navigate(-1)}}>확인</Button>
					</PaymentForm>
				</MainLayout>
			</PullToRefresh>
		);
	};
	return render();
};

export default PaymentInfo;